import React from 'react';
import Search from './Components/Search';
import Footer from './Components/Footer';

function App() {

  return (
    <div className='app-container'>
      <Search />
      <Footer />
    </div>
  )
}

export default App